import './App.css';
import Nav from './component/nav/Nav';
import Route from './Route';
import "tailwindcss"

function App() {
  return (
    <div className="App">
      <Route/>  
    </div> 
  );
}

export default App;
